export class CustomError extends Error {
  public code: number
  public data?: any

  constructor(message: string, code: number, data?: any) {
    super(message)
    this.code = code
    this.data = data
    Object.setPrototypeOf(this, CustomError.prototype)
  }
}
